import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";

import {FullScreen, useFullScreenHandle} from "react-full-screen";





import 'primeicons/primeicons.css';


import Invoice from "./pages/Invoice";
import React from "react";


import 'react-overlay-loader/styles.css';
import Purchase from "./pages/Purchase";
import Voucher from "./pages/Voucher";
import CustomerAccount from "./pages/CustomerAccount";
import CustomerLedger from "./pages/CustomerLedger";
import Inventory from "./pages/Inventory";
import StockDetails from "./pages/StockDetails";
import Post from "./pages/Post";
import ItemEditor from "./pages/ItemEditor";
import CustomerEditor from "./pages/CustomerEditor";
import {SummeryAccount} from "./pages/Summery";
import SignUp from "./pages/SignUp";
import Login from "./pages/Login";
import Home from "./pages/Home";


import {Rma} from "./pages/RMA";
import {Worker} from "./pages/Worker";

import WorkerReport from "./pages/WorkerReport";
import {Kit} from "./pages/Kit";
import {MfxInput} from "./pages/MfxInput";
import {MfxOutput} from "./pages/MfxOutput";
import {DashBoard} from "./pages/DashBoard";

import {CashBook} from "./pages/CashBook";
import {useIdleTimers} from "./utilities/UseIdleTimer";

import DocumentUploader from "./pages/DocumentUploader";
import ItemAnalytics from "./pages/ItemAnalytics";


function App() {
    const handle = useFullScreenHandle();
    const onIdle = () => {
        // Implement your logout logic here
        console.log('User is idle. Logging out...');
        // Example: Clear localStorage and redirect
        localStorage.removeItem('authToken');
        window.location.href = '/login';
    };

    useIdleTimers(10);
    return (
        <>
            <FullScreen handle={handle}>
                <BrowserRouter>

                                            <Routes>
                                                <Route path="/" element={<Login/>} />
                                                <Route path="/home" element={<Home handle={handle}/>}/>
                                                <Route path="/upload" element={<DocumentUploader handle={handle}/>}/>
                                                <Route path="/login" element={<Login/>}/>
                                                <Route path="/item-analytics" element={<ItemAnalytics handle = {handle}/>} />
                                                <Route path="/item" element={<ItemEditor  handle={handle}/>}/>
                                                <Route path="/customer" element={<CustomerAccount handle={handle}/>}/>
                                                <Route path="/inventory" element={<Inventory handle={handle}/>}/>
                                                <Route path="/purchase" element={<Purchase handle={handle}/>}/>
                                                <Route path="/voucher" element={<Voucher handle={handle}/>}/>
                                                <Route path="/cashbook" element={<CashBook handle={handle}/>}/>
                                                <Route path="/customerEdit" element={<CustomerEditor handle={handle}/>}/>
                                                <Route path="/stock" element={<StockDetails handle={handle}/>}/>
                                                <Route path="/post" element={<Post handle={handle}/>}/>
                                                <Route path="/summery" element={<SummeryAccount handle={handle}/>}/>
                                                   <Route path="/signUp" element={<SignUp handle={handle}/>}/>
                                                <Route path="/invoice" element={<Invoice handle={handle}/>}/>
                                                <Route path="/ledger" element={<CustomerLedger handle={handle}/>}/>
                                                <Route path="/rma" element={<Rma handle={handle}/>}/>
                                                <Route path="/worker" element={<Worker handle={handle}/>}/>
                                                <Route path="/workerReport" element={<WorkerReport handle={handle}/>}/>
                                                <Route path="/kit" element={<Kit handle={handle}/>}/>
                                                <Route path="/mfxInput" element={<MfxInput handle={handle}/>}/>
                                                <Route path="/mfxOutput" element={<MfxOutput handle={handle}/>}/>
                                                <Route path="/dashboard" element={<DashBoard handle={handle}/>}/>
                                            </Routes>

                </BrowserRouter>
            </FullScreen>

        </>
    );
}

export default App;
